<script lang="ts">
  import { layout, openSettings } from '../state/layout.svelte'
  import { places } from '../state/places.svelte'
  import ConnectionBanner from './ConnectionBanner.svelte'
  import DesktopLayout from './DesktopLayout.svelte'
  import MobileLayout from './MobileLayout.svelte'
  import PlacesOffer from './PlacesOffer.svelte'

  let { cartoKey }: { cartoKey: string } = $props()

  // The filled star asks for its place's row, which lives on the Settings
  // screen. `Places` scrolls to the row and clears the request once it is up.
  $effect(() => {
    if (places.focus) openSettings()
  })

  let banner = $state(false)
</script>

<div class="shell" class:banner>
  <!-- Above the app, never over it (round 2's 3.7). -->
  <ConnectionBanner bind:shown={banner} />
  <div class="app-body">
    <!-- Keyed on the layout so switching across the 900 px breakpoint tears
         the map down and rebuilds it with the right controls, rather than
         leaving desktop zoom buttons on a phone-width screen. -->
    {#if layout.isDesktop}
      <DesktopLayout {cartoKey} />
    {:else}
      <MobileLayout {cartoKey} />
    {/if}
  </div>
</div>

<!-- Places from a `#places=` link, waiting for Add or Ignore. Outside both
     layouts because a link can be opened on either. -->
<PlacesOffer />

<style>
  .shell {
    display: flex;
    flex-direction: column;
    /* dvh tracks the collapsing URL bar; vh is the fallback for older iOS. */
    height: 100vh;
    height: 100dvh;
    overflow: hidden;
  }

  .app-body {
    position: relative;
    flex: 1;
    min-height: 0;
  }

  /* The banner has taken the status bar's inset, so nothing under it adds
     the notch a second time. */
  .shell.banner .app-body {
    --safe-top: 0px;
  }
</style>
